var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"home-header d-flex my-3"},[_c('v-card-text',{staticClass:"pa-md-3"},[_c('h2',{staticClass:"headline sm1 text-uppercase",staticStyle:{"line-height":"1.2"}},[_vm._v(" "+_vm._s(_vm.data.title)),(_vm.subtitle)?_c('span',{staticClass:"pl-2"},[_vm._v("- "+_vm._s(_vm.data.subtitle))]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }